import { storeToRefs } from 'pinia'
import { useAuthStore } from '../stores/auth'
import { useRouter } from 'vue-router'

export function useAuth() {
  const store = useAuthStore()
  const router = useRouter()
  const { user, isAuthenticated } = storeToRefs(store)

  const login = async (email: string, password: string) => {
    await store.login(email, password)
    //router.push('/')
  }

  const logout = async () => {
    await store.logout()
    router.push('/')
  }

  return {
    user,
    isAuthenticated,
    login,
    logout
  }
}